import { GameObject } from "../core/GameObject";
import { GameScene } from "../scenes/GameScene";
import { DestroyInWall } from "./DestroyInWall";
import { DestroyOffscreen } from "./DestroyOffscreen";
import { PlanckBodyComponent, PlanckBodyType } from "./PlanckBodyComponent";
import { SpineAnimation } from "./SpineAnimation";

export class Dynamite extends GameObject {
	spine: SpineGameObject;
	spineContainer: SpineContainer;
	grounded: boolean;
	groundAnimations = ["powerup-dynamite-ground"]
	skyAnimations = ["powerup-dynamite-sky"];
	constructor(scene: GameScene, x: number, y: number, grounded: boolean, speed: number) {
		super(scene);

		this.grounded = grounded;

		let animationName =  grounded ? this.groundAnimations[Phaser.Math.RND.between(0, this.groundAnimations.length - 1)] : this.skyAnimations[Phaser.Math.RND.between(0, this.skyAnimations.length - 1)];
		const spine = this.spine = scene.add.spine(0, 0, animationName);
		spine.scale = 0.5;
		if(animationName.includes("dynamite"))spine.play("idle", true);

		if (grounded) spine.y += 120;
		if (!grounded) spine.y += 60;

		const width = spine.displayWidth * 0.85;
		const height = spine.displayHeight * 0.8;
		this.setSize(width, height);

		this.x = x;
		this.y = y;
		if (grounded) this.y -= (height * 0.4);

		const planckBody = this.addComponent(new PlanckBodyComponent(this, PlanckBodyType.BOX, {
			x: this.x, y: this.y,
			width: width, height: height,
			worldScale: GameScene.worldScale,
			isKinematic: grounded,
			isSensor: false,
		}));

		// const hitbox = this.addImage("whiteSquare");
		// hitbox.alpha = 0.5;
		// hitbox.setDisplaySize(width, height);

		if (grounded) planckBody.velocity.x = speed;

		this.addComponent(new SpineAnimation(this, spine, animationName, true, spine.x, spine.y));
		this.addComponent(new DestroyOffscreen(this, true, false));
		this.addComponent(new DestroyInWall(this));
	}

	playHitAnimation(): void{
		this.spine.play("hit", false);
		this.spine.once("complete", () =>{
			this.destroy();
		})
	}
}